import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface PhonePictoProps extends pictoProps {
}

export interface PhonePictoState extends pictoState {
}

export class PhonePicto extends Picto<PhonePictoProps,PhonePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.phonePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(PhonePicto);
